import { SFContact } from '@shared/entities/sf-contact';
import { SFCustomerPartner } from '@shared/entities/sf-customer-partner';

export interface ContactBase {
  id?: string;
  accountId?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  mobilePhone?: string;
}

export type SFEntity = SFContact | SFCustomerPartner;

export function isSFContact(contact: SFEntity): contact is SFContact {
  return 'roleMyICAM' in contact || 'profileMyICAM' in contact || 'myICAM' in contact;
}

export function isSFCustomerPartner(contact: SFEntity): contact is SFCustomerPartner {
  return 'partner' in contact || 'locationId' in contact || 'displayName' in contact;
}

export function getContactProperties(contact: SFEntity): ContactBase {
  return {
    id: contact.id,
    accountId: contact.accountId,
    firstName: contact.firstName,
    lastName: contact.lastName,
    email: contact.email,
    mobilePhone: contact.mobilePhone
  };
}

export function getContactFullName(contact: SFEntity | null | undefined): string {
  if (!contact) return '';

  const firstName = contact.firstName || '';
  const lastName = contact.lastName || '';
  return `${firstName} ${lastName}`.trim();
}

export function formatContactDisplay(contact: SFEntity | null | undefined): string {
  if (!contact) return '';

  const name = getContactFullName(contact);
  const email = contact.email || '';

  return name && email ? `${name} (${email})` : name || email;
}
